import { useTranslation } from "react-i18next";
import { useReferenceValueLabel, useTimeframes } from "../../../api/hooks/useReference";
import type { TrackerStrategyDto } from "../../../api/hooks/usePortfolioTracker";
import { displayTicker } from "../../trading-strategies/tickers";
import { useTradesThrough } from "../useTradesThrough";

/**
 * A strategy as the tracker names it: the symbol it charts and its name, then which way it trades, what
 * through and on what timeframe. Two versions of a strategy share a name, so the second line tells them apart.
 */
export function TrackerStrategyIdent({ strategy }: { strategy: TrackerStrategyDto }) {
  const { t } = useTranslation("tradingStrategies");
  const timeframeLabel = useReferenceValueLabel(useTimeframes().data);
  const through = useTradesThrough()(strategy);

  return (
    <span className="tracker-ident">
      <span className="tracker-ident-top">
        <span className="tracker-ticker">{displayTicker(strategy.chartedSymbol) ?? ""}</span>
        <span className="tracker-ident-name">{strategy.name}</span>
      </span>
      <span className="tracker-ident-sub">
        {strategy.direction > 0 && (
          <>
            <span>{t(`sides.${strategy.direction}`)}</span>
            <span aria-hidden="true">·</span>
          </>
        )}
        <span>{through}</span>
        <span className="tracker-timeframe">{timeframeLabel(strategy.timeframe)}</span>
      </span>
    </span>
  );
}
